const STORAGE_PREFIX = 'walletAlert'
const ONE_DAY_MS = 24 * 60 * 60 * 1000

const buildStorageKey = ({ alertKey, scopeId }) => {
  const scope = scopeId || 'sem-escopo'
  return `${STORAGE_PREFIX}:${alertKey}:${scope}`
}

const readEntry = (storageKey) => {
  try {
    const raw = globalThis.localStorage.getItem(storageKey)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return parsed
  } catch {
    return null
  }
}

export const isWalletAlertDismissed = ({
  alertKey,
  scopeId,
  signature,
  ttlMs = ONE_DAY_MS,
}) => {
  const entry = readEntry(buildStorageKey({ alertKey, scopeId }))
  if (!entry) return false
  const withinTtl = Date.now() - entry.at < ttlMs
  const sameSignature = entry.signature === signature
  return withinTtl && sameSignature
}

export const dismissWalletAlert = ({ alertKey, scopeId, signature }) => {
  try {
    const payload = JSON.stringify({
      at: Date.now(),
      signature: signature || '',
    })
    globalThis.localStorage.setItem(
      buildStorageKey({ alertKey, scopeId }),
      payload
    )
    return true
  } catch {
    return false
  }
}

export { ONE_DAY_MS }
